import 'babel-polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VueI18n from 'vue-i18n'

import App from './App.vue'
import router from './router'
import store from './store'

import es from './lang/es.json'

import colors from 'vuetify/lib/util/colors'
import 'material-design-icons-iconfont/dist/material-design-icons.css'


Vue.use(Vuetify)
Vue.use(VueI18n)

Vue.config.productionTip = false

const token = localStorage.getItem('token');
if (token) {
    store.dispatch('tokenCheck', token)
}

export const i18n = new VueI18n({
    locale: 'es',
    messages:{ es }
})

const vuetify = new Vuetify({
    theme: {
        themes: {
            light: {
                primary: colors.teal.base,
                secondary: colors.indigo.secondary,
                accent: colors.indigo.accent4
            },
        },
    },
})

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app')
